import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
  authUser: null,
  preAuthUser: null,
  forgotPasswordIsOpen: false,
  reloadData: false,
  red_email: "",
  red_password: "",
  loginPage: false,
};

export const global = createSlice({
  name: "global",
  initialState,
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setLoginPage: (state, action) => {
      state.loginPage = action.payload;
    },
    setAuthenticUser: (state, action) => {
      state.authUser = action.payload;
    },
    setPreAuthenticUser: (state, action) => {
      state.preAuthUser = action.payload;
    },
    setForgotPasswordIsOpen: (state, action) => {
      state.forgotPasswordIsOpen = action.payload;
    },
    setReloadData: (state, action) => {
      state.reloadData = action.payload;
    },
  },
  extraReducers: {},
});

// Action creators are generated for each case reducer function
export const { setLoader, setAuthenticUser, setPreAuthenticUser, setForgotPasswordIsOpen, setReloadData, setLoginPage } =
  global.actions;

export default global.reducer;
